// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/restaurant.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --primary: #01B2BA;
    --secondary : #e2e2e2;
    --title: #000;
    --text: #000;
    --textSecondary: #fff;
    --textException: #ffffff;
    --textButton: #000;
    --navbar: #fff;
}

* {
    margin: 0;
    padding: 0;
    font-family: 'Acme';
    /* font-family: 'Galada', 'Yesteryear', 'Tahoma','Helvetica Neue', sans-serif; */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

body {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

#root {
    width: 100%;
}

/* main {
    max-width: 1350px;
    margin: 0 auto;
} */

a {
    text-decoration: none;
    color: var(--navbar);
}

h1 {
    font-size: 36px;
    color: var(--title);
}

h2 {
    font-size: 24px;
    color: var(--title);
}

h3 {
    font-size: 20px;
    color: var(--title);
}

h4 {
    font-size: 18px;
    color: var(--title);
}

p {
    font-family: 'Tahoma';
    font-size: 14px;
    color: var(--text);
}

/* .couleurOpacity {
    background: rgba(255, 255, 255, 0.4);
    height: 100vh;
} */


/* ***************************************** Header **************************************** */

.headerAccueil {
    height: 100vh;
    position: relative;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-attachment: fixed;
    background-position: center;
}

header {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.logo {
    width: 100px;
}

.resto {
    object-fit: cover;
    width: 100%;
}

.mobile-menu {
    display: none;
}

.desktop-menu {
    margin: 20px 0px;
    font-size: 20px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    z-index: 2;
}

.desktop-menu ul {
    padding: 0 30px;
    list-style-type: none;
    display: flex;
    flex-direction: row;
}

.desktop-menu ul li {
    padding: 0 10px;    
}

@media (max-width: 968px) {
    .resto {
        max-height: 200px;
    }
}

@media screen and (max-width: 768px) {
    .desktop-menu {
        display: none;
    }

    .mobile-menu {
        margin: 20px 0px;
        font-size: 20px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: flex-end;
        width: 100%;
        z-index: 2;
    }
    
    .mobile-menu img {
        background-color: white;
        /* width: 50px;
        padding: 5px; */
        width: 60px;
        padding: 3px;
        border-radius: 10px;
        margin-right: 30px;
    }
    
    .mobile-menu ul {
        margin-right: 30px;
        padding: 0 20px;
        list-style-type: none;
        background-color: rgba(0, 0, 0, 0.5);
        border-radius: 10px;
    }
    
    .menu-items {
        text-align: right;  
        margin-top: 10px;
    }
}

/* ***************************************** Accueil **************************************** */

#accueil {
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
}
/*
.certification {
    position: absolute;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    top: 0;
    left: 10vh;
    z-index: 1;
}
*/
.back-certif {
    padding: 10px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 40px;
}

.accueilTexte {
    position: absolute;
    width: 80%;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    /* justify-content: center; */
    justify-content: space-around;
    top: 0;
    z-index: 1;
}

.accueilTexte .restoLogo {
    padding: 30px;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 40px;
}

.logoAccueil {
    width: 400px;
}

.ouvferm {
    position: absolute;
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    bottom: 40px;
    z-index: 1;
}

.ouvferm div {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.ouvferm h2 {
    color: var(--textException);
    font-size: 36px;
}

.ouvferm h3, .ouvferm p {
    color: var(--textException);
}

.littleTexte {
    font-size: 11px;
}

@media screen and (max-width: 1000px) {    
    .accueilTexte {
        width: 100%;
    }
}

@media screen and (max-width: 400px) {    
    .accueilTexte {
        position: relative;
        height: 80vh;
    }
}

@media screen and (max-width: 768px) {
    .accueilTexte {
        flex-direction: column-reverse;
    }

    .accueilTexte .restoLogo {
        padding: 4vw;
    }

    .logoAccueil {
        width: 50vw;
    }

    .ouvferm p {
        padding: 0 5vw;
        text-align: center;
    }
}


/* ***************************************** Restaurant **************************************** */

#restaurant {
    margin: 20px auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 80%;
    height: 100vh;
    /* border-bottom: 1px solid black; */
    text-align: center;
    padding: 20px 0;
}

#restaurant h1 {
    margin: 20px 0 40px 0;
}
#restaurant p {
    margin-bottom: 20px;
}

.divResto {
    display: flex;
    flex-direction: row;
    gap: 50px;
    align-items: center;
}

@media screen and (max-width: 768px) {    
    #restaurant {
        margin: 10px auto;
        width: 90%;
    }
}

@media screen and (max-width: 600px) {    
    #restaurant {
        margin: 0 auto;
        width: 85%;
        height: auto;
    }
    .divResto {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
    }
}

/* ***************************************** Menu **************************************** */

#menu {
    /* margin: 0 auto; */
    padding: 0 70px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    /* width: 90%; */
    height: 100vh;
    background-color: #FFE361;
}

.menuPhoto img {
    height: 80vh;
    border-radius: 70px;
    box-shadow: 8px 8px 10px rgba(0, 0, 0, 0.6);
}

.menuPhoto {
    width: 35%;
    display: flex;
    justify-content: center;
}

.menus {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 50%;
}

.menus h2 {
    margin-bottom: 40px;
}

.choixMenu {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    width: 100%;
}

.menuPart {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.menuPart h3 {
    margin-bottom: 20px;
}

.menuButton {
    width: 150px;
    height: 70px;
    border-radius: 20px;
    border: none;
    box-shadow: 8px 8px 10px rgba(0, 0, 0, 0.6);
    background: var(--primary);
    font-size: 24px;
    color: var(--textButton);
    cursor: pointer;
}

.menuButton a {
    color: var(--textButton);
}

.menuPart2 {
    width: 70%;
}

.longButton {
    width: 100%;
}

@media screen and (max-width: 900px) {
    #menu {
        padding: 0 40px;
    }
}

@media screen and (max-width: 768px) {

    #menu {
        flex-direction: column;
        height: auto;
        padding: 40px;
    }

    .menuPhoto img {
        height: 50vh;
    }

    .menus {
        width: 100%;
    }

    .menus h2 {
        margin-top: 20px;
        margin-bottom: 20px;
    }
}

@media screen and (max-width: 400px) {
    #menu {
        padding: 30px;
    }

    .menu h2 {
        font-size: 20px;
    }

    .menuButton {
        width: 5em;
        height: 50px;
        border-radius: 10px;
        border: none;
        box-shadow: 5px 5px 8px rgba(0, 0, 0, 0.6);
        font-size: 20px;
    }

    .longButton {
        width: 100%;
    }
}


/* ***************************************** Cuisine **************************************** */

#cuisine {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    /* align-items: center; */
    align-items: stretch;
    width: 100%;
    height: 100%;
    /* background-image: url(../images/bleubois2.jpg); */
    background-color: #00abee;
    /* background-size: cover;
    background-attachment: fixed; */
    /* margin: 0 auto; */
}

.cuisinePhoto {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    width: 15vw;
    background-color: #110a06;
}

#cuisine h2 {
    padding: 20px 0;
}

#cuisine p {
    margin-bottom: 20px;
}

.cuisineText {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 80%;
    padding: 20px;
    /* margin-left: 7%;
    margin-right: 7%; */
}

.cuisineText h3 {
    font-size: 16px;
}

@media screen and (max-width: 768px) {

    #cuisine {
        height: auto;
        flex-direction: column;
    }
  
    .cuisineText {
        width: 80%;
        margin: 0 7%;
        padding: 15px 0;
    }

    .cuisinePhoto {
        flex-direction: row;
        width: auto;
    }

    .cuisinePhoto img {
        height: 20vw;
        margin: 20px 0;
    }

    .hiddenCuisine {
        display: none;
    }
}

/* ***************************************** Réservation **************************************** */

#reservation {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 30px 50px;
    height: 100vh;
    margin: 0 auto;
    border-bottom: 1px solid black;
}

.reservationImage {
    max-width: 30%;
    display: flex;
    justify-content: center;
    margin: 0 auto;
}

.reservationImage img {
    height: 80vh;
    width: 100%;
    object-fit: cover;
}

.reservationGoogle {
    width: 65%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.reservationGoogle h2 {
    margin-bottom: 20px;
}

.reservationGoogle .reservationInfo {
    font-weight: bold;
    color: red;
    text-align: center;
}

.reservationGoogle .espace {
    margin-bottom: 15px;
}

.reservationGoogle .little {
    font-size: 11px;
}

.reservationGoogle .alertInfo {
    font-size: 20px;
}

.reservationGoogle button {
    padding: 10px 30px;
    border-radius: 10px;
    background-color: var(--primary);
    color: var(--textButton);
    font-size: 16px;
}

.reservationGoogle .close {
    padding: 5px 10px;
    font-family: 'Tahoma';
    font-weight: bold;
}

.formulaire {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 10px;
}

.formulaire2 {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.formulaire2 p {
    margin-right: 10px;
}

.formulaire2 input {
    margin-right: 10px;
    padding: 0 10px;
}

#time {
    width: 40px;
}

.formulaire p {
    margin-right: 5px;
}

form {
    width: 100%;
}

.dbl-field {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.message {
    display: flex;
    flex-direction: column;
    width: 80%;
}

textarea {
    width: 100%;
    padding: 10px;
    height: 120px;
    border-radius: 10px;
    margin-top: 5px;
}

@media screen and (max-width: 768px) {

    #reservation {
        flex-direction: column;
        height: auto;
        margin: 30px auto;
    }

    #reservation h2 {
        margin-top: 20px;
    }

    .reservationGoogle {
        width: 100%;
    }

    .reservationImage {
        max-width: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
        margin: 0 auto;
    }
    
    .reservationImage img {
        object-fit: cover;
        height: 40vh;
        width: 100%;
    }

    .formulaire {
        flex-direction: column;
    }

    .formulaire p {
        margin-bottom: 5px;
    }

    .formulaire2 {
        flex-direction: column;
    }
}

@media screen and (max-width: 400px) {
    #reservation {
        padding: 30px 30px;
    }

    .reservationGoogle p {
        font-size: 12px;
    }
}

/* ***************************************** Contact **************************************** */

#contact {
    padding: 50px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
}

.leaflet-container {
    height: 400px;
    width: 50%; 
    box-shadow: 8px 8px 10px rgba(0, 0, 0, 0.6);
}

.contact {
    width: 40%;
}

.contactLigne {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 20px;
}

.contactColonne {
    display: flex;
    flex-direction: column;
    margin-bottom: 40px;
}

.contactLigne p {
    font-weight: 700;
    color: var(--text);
}

.contactColonne .small {
    font-size: 11px
}

.contactLigne img {
    height: 30px;
    margin: 0 20px;
}

.contactLigne .sociaux {
    margin: 0;
    margin-left: 20px;
}

@media screen and (max-width: 768px) {

    #contact {
        flex-direction: column;
    }

    .leaflet-container {
        height: 300px;
        width: 100%;
        box-shadow: 5px 5px 8px rgba(0, 0, 0, 0.6);
    }

    .contact {
        width: 100%;
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .contactLigne {
        margin-bottom: 10px;
    }
}

/* ***************************************** Footer **************************************** */

footer {
    background-color: var(--secondary);
    padding: 20px 20px 10px 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

footer div {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    width: 20%;
}

footer a {
    text-decoration: none;
    color: var(--text);
}

@media screen and (max-width: 768px) {

    footer div {
        width: 50%;
    }
}


/* ***************************************** CGV et Mentions légales **************************************** */

.conditions {
    padding: 30px 80px;
}

.conditions div {
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
}

.buttonAccueil {
    padding: 10px 20px;
    border-radius: 10px;
    border: 0;
    background-color: var(--primary);
    box-shadow: 5px 5px 8px rgba(0, 0, 0, 0.6);
    font-weight: bold;
}

.conditions h1 {
    font-size: 28px;
    margin-bottom: 20px;
}

.conditions h2 {
    font-size: 20px;
    margin: 20px 0 10px 0;
}

.conditions h3 {
    font-size: 18px;
    font-weight: normal;
    text-decoration: underline;
    margin: 20px 0 10px 0;
}

.conditions .credits h3 {
    text-decoration: none;
    margin: 40px 0 10px 0;
}

.conditions ul {
    padding-left: 30px;
    margin-bottom: 10px;
}

.conditions section {
    margin-bottom: 15px;
}

@media screen and (max-width: 768px) {

    .conditions {
        padding: 30px;
    }
}

/* *****************************************  Page 404  ***************************************** */

.page404 {
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
}

.page404 img {
    width: 60%;
    height: 200px;
    object-fit: cover;
    border-radius: 20px;
}

.page404 h1 {
    font-size: 10em;
    color: red;
}

@media screen and (max-width: 400px) {
    .page404 h1 {
        font-size: 4.5em;
    }
}

@media screen and (max-width: 768px) {

    .page404 img {
        width: 70%;
    }

    .page404 h1 {
        font-size: 6.3em;
    }
}


/* *****************************************  Grands écrans  ***************************************** */

@media (min-width: 1400px) {
    h1 {
        font-size: 2.7vw;
    }
    
    h2 {
        font-size: 1.8vw;
    }
    
    h3 {
        font-size: 1.5vw;
    }

    h4 {
        font-size: 1.3vw;
    }
    
    p {
        font-size: 1.1vw;
    }

    .desktop-menu {
        font-size: 1.5vw;
    }

    .desktop-menu ul {
        padding: 0 2.1vw;
    }
    
    .desktop-menu ul li {
        padding: 0 0.7vw;    
    }

    .ouvferm h2 {
        font-size: 2.7vw;
    }

    .ouvferm {
        bottom: 3vw;
    }

    .logo {
        width: 7.4vw;
    }

    .logoAccueil {
        width: 29.6vw;
    }

    #restaurant h1 {
        margin: 1.5vw 0 3vw 0;
    }
    #restaurant p {
        margin-bottom: 1.5vw;
    }

    #menu {
        padding: 0 5.2vw;
    }

    .menus h2 {
        margin-bottom: 3vw;
    }

    .menuPart h3 {
        margin-bottom: 1.5vw;
    }

    .menuButton {
        font-size: 1.8vw;
        width: 11.1vw;
        height: 5.2vw;
    }

    .longButton {
        width: 100%;
    }

    #cuisine h2 {
        padding: 1.5vw 0;
    }
    
    #cuisine p {
        margin-bottom: 1.5vw;
    }

    .cuisineText h3 {
        font-size: 1.2vw;
    }
    #reservation {
        padding: 2.2vw 3.7vw;
    }

    .reservationGoogle .close {
        padding: 0.4vw 0.7vw;
    }
    
    .reservationGoogle h2 {
        margin-bottom: 1.5vw;
    }
    
    .reservationGoogle button {
        padding: 0.7vw 2.2vw;
        font-size: 1.2vw;
    }

    .formulaire {
       margin-bottom: 0.7vw;
    }

    .formulaire2 p {
        margin-right: 0.7vw;
    }
    
    .formulaire2 input {
        margin-right: 0.7vw;
        padding: 0 0.7vw;
    }
    
    .formulaire p {
        margin-right: 0.4vw;
    }    

    input {
        height: 1.3vw;
        font-size: 1.1vw;
    }

    #time {
        width: 3vw;
    }

    textarea {
        padding: 0.7vw;
        height: 11.1vw;
        border-radius: 0.7vw;
        margin-top: 0.4vw;
    }

    #contact {
        padding: 3.7vw;
    }

    .leaflet-container {
        height: 29.6vw;
    }

    .contactLigne {
        margin-bottom: 1.5vw;
    }

    .contactLigne img {
        height: 2.2vw;
        margin: 0 1.5vw;
    }

    footer {
        padding: 1.5vw 1.5vw 0.7vw 1.5vw;
    }


    .conditions {
        padding: 30px 80px;
    }
    
    .conditions div {
        display: flex;
        justify-content: center;
        margin-bottom: 30px;
    }
    
    .buttonAccueil {
        padding: 0.7vw 1.5vw;
        border-radius: 0.7vw;
    }
    
    .conditions h1 {
        font-size: 2.1vw;
        margin-bottom: 1.5vw;
    }
    
    .conditions h2 {
        font-size: 1.5vw;
        margin: 1.5vw 0 0.7vw 0;
    }
    
    .conditions h3 {
        font-size: 1.3vw;
        margin: 1.5vw 0 0.7vw 0;
    }
    
    .conditions ul {
        padding-left: 2.2vw;
        margin-bottom: 0.7vw;
    }
    
    .conditions section {
        margin-bottom: 1.1vw;
    }

    .page404 img {
        height: 14.8vw;
        border-radius: 1.5vw;
    }

    .page404 h1 {
        font-size: 12vw;
        color: red;
    }
}

/* Mise en avant promotion */

.miseEnAvant {
    background: red;
    color: var(--textException);
    margin-top: 4vw;
    width: 300px;
}

@media screen and (max-width: 768px) {
    .miseEnAvant {
        margin-top: 7vw;
        height: 65px;
        width: 6em;
    }
}

@media screen and (max-width: 768px) {
    .miseEnAvant {
        width: 200px;
    }
}



.hidden {
    display: none;
}`, "",{"version":3,"sources":["webpack://./src/style/index.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,YAAY;IACZ,qBAAqB;IACrB,wBAAwB;IACxB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,gFAAgF;IAChF,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;;;GAGG;;AAEH;IACI,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,kBAAkB;AACtB;;AAEA;;;GAGG;;;AAGH,8FAA8F;;AAE9F;IACI,aAAa;IACb,kBAAkB;IAClB,yDAA+C;IAC/C,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,aAAa;QACb,sBAAsB;QACtB,yBAAyB;QACzB,qBAAqB;QACrB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,uBAAuB;QACvB;uBACe;QACf,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf,qBAAqB;QACrB,oCAAoC;QACpC,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;IACpB;AACJ;;AAEA,+FAA+F;;AAE/F;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,uBAAuB;AAC3B;AACA;;;;;;;;;;;CAWC;AACD;IACI,aAAa;IACb,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,6BAA6B;IAC7B,6BAA6B;IAC7B,MAAM;IACN,UAAU;AACd;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,8BAA8B;IAClC;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,cAAc;QACd,kBAAkB;IACtB;AACJ;;;AAGA,kGAAkG;;AAElG;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,aAAa;IACb,oCAAoC;IACpC,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI;QACI,iBAAiB;QACjB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,cAAc;QACd,UAAU;QACV,YAAY;IAChB;IACA;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;QACT,mBAAmB;IACvB;AACJ;;AAEA,4FAA4F;;AAE5F;IACI,oBAAoB;IACpB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,6BAA6B;IAC7B,gBAAgB;IAChB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,2CAA2C;AAC/C;;AAEA;IACI,UAAU;IACV,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,2CAA2C;IAC3C,0BAA0B;IAC1B,eAAe;IACf,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;;IAEI;QACI,sBAAsB;QACtB,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,YAAY;QACZ,mBAAmB;QACnB,YAAY;QACZ,0CAA0C;QAC1C,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;AACJ;;;AAGA,+FAA+F;;AAE/F;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,yBAAyB;IACzB,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,oDAAoD;IACpD,yBAAyB;IACzB;mCAC+B;IAC/B,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,aAAa;IACb;uBACmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI;QACI,YAAY;QACZ,sBAAsB;IAC1B;;IAEA;QACI,UAAU;QACV,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA,mGAAmG;;AAEnG;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;IAEI;QACI,sBAAsB;QACtB,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,WAAW;QACX,aAAa;QACb,uBAAuB;QACvB,cAAc;IAClB;;IAEA;QACI,iBAAiB;QACjB,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,+FAA+F;;AAE/F;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,2CAA2C;AAC/C;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,iBAAiB;AACrB;;AAEA;;IAEI;QACI,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,WAAW;QACX,0CAA0C;IAC9C;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,aAAa;QACb,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA,8FAA8F;;AAE9F;IACI,kCAAkC;IAClC,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;;IAEI;QACI,UAAU;IACd;AACJ;;;AAGA,+GAA+G;;AAE/G;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;IACT,gCAAgC;IAChC,0CAA0C;IAC1C,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI;QACI,aAAa;IACjB;AACJ;;AAEA,mGAAmG;;AAEnG;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,UAAU;AACd;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;;IAEI;QACI,UAAU;IACd;;IAEA;QACI,gBAAgB;IACpB;AACJ;;;AAGA,wGAAwG;;AAExG;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,qBAAqB;IACzB;IACA;QACI,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;IACpB;IACA;QACI,oBAAoB;IACxB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,oBAAoB;QACpB,gBAAgB;IACpB;;IAEA;OACG,oBAAoB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,cAAc;QACd,cAAc;QACd,oBAAoB;QACpB,iBAAiB;IACrB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,gCAAgC;IACpC;;;IAGA;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;QACpB,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;QAChB,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;QACI,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,cAAc;QACd,oBAAoB;IACxB;;IAEA;QACI,eAAe;QACf,UAAU;IACd;AACJ;;AAEA,4BAA4B;;AAE5B;IACI,eAAe;IACf,2BAA2B;IAC3B,eAAe;IACf,YAAY;AAChB;;AAEA;IACI;QACI,eAAe;QACf,YAAY;QACZ,UAAU;IACd;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;;;AAIA;IACI,aAAa;AACjB","sourcesContent":[":root {\n    --primary: #01B2BA;\n    --secondary : #e2e2e2;\n    --title: #000;\n    --text: #000;\n    --textSecondary: #fff;\n    --textException: #ffffff;\n    --textButton: #000;\n    --navbar: #fff;\n}\n\n* {\n    margin: 0;\n    padding: 0;\n    font-family: 'Acme';\n    /* font-family: 'Galada', 'Yesteryear', 'Tahoma','Helvetica Neue', sans-serif; */\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\nbody {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n#root {\n    width: 100%;\n}\n\n/* main {\n    max-width: 1350px;\n    margin: 0 auto;\n} */\n\na {\n    text-decoration: none;\n    color: var(--navbar);\n}\n\nh1 {\n    font-size: 36px;\n    color: var(--title);\n}\n\nh2 {\n    font-size: 24px;\n    color: var(--title);\n}\n\nh3 {\n    font-size: 20px;\n    color: var(--title);\n}\n\nh4 {\n    font-size: 18px;\n    color: var(--title);\n}\n\np {\n    font-family: 'Tahoma';\n    font-size: 14px;\n    color: var(--text);\n}\n\n/* .couleurOpacity {\n    background: rgba(255, 255, 255, 0.4);\n    height: 100vh;\n} */\n\n\n/* ***************************************** Header **************************************** */\n\n.headerAccueil {\n    height: 100vh;\n    position: relative;\n    background-image: url(../images/restaurant.jpg);\n    background-size: cover;\n    background-attachment: fixed;\n    background-position: center;\n}\n\nheader {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.logo {\n    width: 100px;\n}\n\n.resto {\n    object-fit: cover;\n    width: 100%;\n}\n\n.mobile-menu {\n    display: none;\n}\n\n.desktop-menu {\n    margin: 20px 0px;\n    font-size: 20px;\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n    align-items: center;\n    width: 100%;\n    z-index: 2;\n}\n\n.desktop-menu ul {\n    padding: 0 30px;\n    list-style-type: none;\n    display: flex;\n    flex-direction: row;\n}\n\n.desktop-menu ul li {\n    padding: 0 10px;    \n}\n\n@media (max-width: 968px) {\n    .resto {\n        max-height: 200px;\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .desktop-menu {\n        display: none;\n    }\n\n    .mobile-menu {\n        margin: 20px 0px;\n        font-size: 20px;\n        display: flex;\n        flex-direction: column;\n        justify-content: flex-end;\n        align-items: flex-end;\n        width: 100%;\n        z-index: 2;\n    }\n    \n    .mobile-menu img {\n        background-color: white;\n        /* width: 50px;\n        padding: 5px; */\n        width: 60px;\n        padding: 3px;\n        border-radius: 10px;\n        margin-right: 30px;\n    }\n    \n    .mobile-menu ul {\n        margin-right: 30px;\n        padding: 0 20px;\n        list-style-type: none;\n        background-color: rgba(0, 0, 0, 0.5);\n        border-radius: 10px;\n    }\n    \n    .menu-items {\n        text-align: right;  \n        margin-top: 10px;\n    }\n}\n\n/* ***************************************** Accueil **************************************** */\n\n#accueil {\n    width: 100%;\n    height: 100vh;\n    display: flex;\n    justify-content: center;\n}\n/*\n.certification {\n    position: absolute;\n    height: 100vh;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    top: 0;\n    left: 10vh;\n    z-index: 1;\n}\n*/\n.back-certif {\n    padding: 10px;\n    background: rgba(255, 255, 255, 0.8);\n    border-radius: 40px;\n}\n\n.accueilTexte {\n    position: absolute;\n    width: 80%;\n    height: 100vh;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    /* justify-content: center; */\n    justify-content: space-around;\n    top: 0;\n    z-index: 1;\n}\n\n.accueilTexte .restoLogo {\n    padding: 30px;\n    background: rgba(255, 255, 255, 0.5);\n    border-radius: 40px;\n}\n\n.logoAccueil {\n    width: 400px;\n}\n\n.ouvferm {\n    position: absolute;\n    width: 100%;\n    height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-end;\n    bottom: 40px;\n    z-index: 1;\n}\n\n.ouvferm div {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.ouvferm h2 {\n    color: var(--textException);\n    font-size: 36px;\n}\n\n.ouvferm h3, .ouvferm p {\n    color: var(--textException);\n}\n\n.littleTexte {\n    font-size: 11px;\n}\n\n@media screen and (max-width: 1000px) {    \n    .accueilTexte {\n        width: 100%;\n    }\n}\n\n@media screen and (max-width: 400px) {    \n    .accueilTexte {\n        position: relative;\n        height: 80vh;\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .accueilTexte {\n        flex-direction: column-reverse;\n    }\n\n    .accueilTexte .restoLogo {\n        padding: 4vw;\n    }\n\n    .logoAccueil {\n        width: 50vw;\n    }\n\n    .ouvferm p {\n        padding: 0 5vw;\n        text-align: center;\n    }\n}\n\n\n/* ***************************************** Restaurant **************************************** */\n\n#restaurant {\n    margin: 20px auto;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 80%;\n    height: 100vh;\n    /* border-bottom: 1px solid black; */\n    text-align: center;\n    padding: 20px 0;\n}\n\n#restaurant h1 {\n    margin: 20px 0 40px 0;\n}\n#restaurant p {\n    margin-bottom: 20px;\n}\n\n.divResto {\n    display: flex;\n    flex-direction: row;\n    gap: 50px;\n    align-items: center;\n}\n\n@media screen and (max-width: 768px) {    \n    #restaurant {\n        margin: 10px auto;\n        width: 90%;\n    }\n}\n\n@media screen and (max-width: 600px) {    \n    #restaurant {\n        margin: 0 auto;\n        width: 85%;\n        height: auto;\n    }\n    .divResto {\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n        align-items: center;\n    }\n}\n\n/* ***************************************** Menu **************************************** */\n\n#menu {\n    /* margin: 0 auto; */\n    padding: 0 70px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-around;\n    /* width: 90%; */\n    height: 100vh;\n    background-color: #FFE361;\n}\n\n.menuPhoto img {\n    height: 80vh;\n    border-radius: 70px;\n    box-shadow: 8px 8px 10px rgba(0, 0, 0, 0.6);\n}\n\n.menuPhoto {\n    width: 35%;\n    display: flex;\n    justify-content: center;\n}\n\n.menus {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 50%;\n}\n\n.menus h2 {\n    margin-bottom: 40px;\n}\n\n.choixMenu {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-around;\n    width: 100%;\n}\n\n.menuPart {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.menuPart h3 {\n    margin-bottom: 20px;\n}\n\n.menuButton {\n    width: 150px;\n    height: 70px;\n    border-radius: 20px;\n    border: none;\n    box-shadow: 8px 8px 10px rgba(0, 0, 0, 0.6);\n    background: var(--primary);\n    font-size: 24px;\n    color: var(--textButton);\n    cursor: pointer;\n}\n\n.menuButton a {\n    color: var(--textButton);\n}\n\n.menuPart2 {\n    width: 70%;\n}\n\n.longButton {\n    width: 100%;\n}\n\n@media screen and (max-width: 900px) {\n    #menu {\n        padding: 0 40px;\n    }\n}\n\n@media screen and (max-width: 768px) {\n\n    #menu {\n        flex-direction: column;\n        height: auto;\n        padding: 40px;\n    }\n\n    .menuPhoto img {\n        height: 50vh;\n    }\n\n    .menus {\n        width: 100%;\n    }\n\n    .menus h2 {\n        margin-top: 20px;\n        margin-bottom: 20px;\n    }\n}\n\n@media screen and (max-width: 400px) {\n    #menu {\n        padding: 30px;\n    }\n\n    .menu h2 {\n        font-size: 20px;\n    }\n\n    .menuButton {\n        width: 5em;\n        height: 50px;\n        border-radius: 10px;\n        border: none;\n        box-shadow: 5px 5px 8px rgba(0, 0, 0, 0.6);\n        font-size: 20px;\n    }\n\n    .longButton {\n        width: 100%;\n    }\n}\n\n\n/* ***************************************** Cuisine **************************************** */\n\n#cuisine {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    /* align-items: center; */\n    align-items: stretch;\n    width: 100%;\n    height: 100%;\n    /* background-image: url(../images/bleubois2.jpg); */\n    background-color: #00abee;\n    /* background-size: cover;\n    background-attachment: fixed; */\n    /* margin: 0 auto; */\n}\n\n.cuisinePhoto {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-evenly;\n    width: 15vw;\n    background-color: #110a06;\n}\n\n#cuisine h2 {\n    padding: 20px 0;\n}\n\n#cuisine p {\n    margin-bottom: 20px;\n}\n\n.cuisineText {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    width: 80%;\n    padding: 20px;\n    /* margin-left: 7%;\n    margin-right: 7%; */\n}\n\n.cuisineText h3 {\n    font-size: 16px;\n}\n\n@media screen and (max-width: 768px) {\n\n    #cuisine {\n        height: auto;\n        flex-direction: column;\n    }\n  \n    .cuisineText {\n        width: 80%;\n        margin: 0 7%;\n        padding: 15px 0;\n    }\n\n    .cuisinePhoto {\n        flex-direction: row;\n        width: auto;\n    }\n\n    .cuisinePhoto img {\n        height: 20vw;\n        margin: 20px 0;\n    }\n\n    .hiddenCuisine {\n        display: none;\n    }\n}\n\n/* ***************************************** Réservation **************************************** */\n\n#reservation {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    padding: 30px 50px;\n    height: 100vh;\n    margin: 0 auto;\n    border-bottom: 1px solid black;\n}\n\n.reservationImage {\n    max-width: 30%;\n    display: flex;\n    justify-content: center;\n    margin: 0 auto;\n}\n\n.reservationImage img {\n    height: 80vh;\n    width: 100%;\n    object-fit: cover;\n}\n\n.reservationGoogle {\n    width: 65%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.reservationGoogle h2 {\n    margin-bottom: 20px;\n}\n\n.reservationGoogle .reservationInfo {\n    font-weight: bold;\n    color: red;\n    text-align: center;\n}\n\n.reservationGoogle .espace {\n    margin-bottom: 15px;\n}\n\n.reservationGoogle .little {\n    font-size: 11px;\n}\n\n.reservationGoogle .alertInfo {\n    font-size: 20px;\n}\n\n.reservationGoogle button {\n    padding: 10px 30px;\n    border-radius: 10px;\n    background-color: var(--primary);\n    color: var(--textButton);\n    font-size: 16px;\n}\n\n.reservationGoogle .close {\n    padding: 5px 10px;\n    font-family: 'Tahoma';\n    font-weight: bold;\n}\n\n.formulaire {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    margin-bottom: 10px;\n}\n\n.formulaire2 {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.formulaire2 p {\n    margin-right: 10px;\n}\n\n.formulaire2 input {\n    margin-right: 10px;\n    padding: 0 10px;\n}\n\n#time {\n    width: 40px;\n}\n\n.formulaire p {\n    margin-right: 5px;\n}\n\nform {\n    width: 100%;\n}\n\n.dbl-field {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.message {\n    display: flex;\n    flex-direction: column;\n    width: 80%;\n}\n\ntextarea {\n    width: 100%;\n    padding: 10px;\n    height: 120px;\n    border-radius: 10px;\n    margin-top: 5px;\n}\n\n@media screen and (max-width: 768px) {\n\n    #reservation {\n        flex-direction: column;\n        height: auto;\n        margin: 30px auto;\n    }\n\n    #reservation h2 {\n        margin-top: 20px;\n    }\n\n    .reservationGoogle {\n        width: 100%;\n    }\n\n    .reservationImage {\n        max-width: 100%;\n        width: 100%;\n        display: flex;\n        justify-content: center;\n        margin: 0 auto;\n    }\n    \n    .reservationImage img {\n        object-fit: cover;\n        height: 40vh;\n        width: 100%;\n    }\n\n    .formulaire {\n        flex-direction: column;\n    }\n\n    .formulaire p {\n        margin-bottom: 5px;\n    }\n\n    .formulaire2 {\n        flex-direction: column;\n    }\n}\n\n@media screen and (max-width: 400px) {\n    #reservation {\n        padding: 30px 30px;\n    }\n\n    .reservationGoogle p {\n        font-size: 12px;\n    }\n}\n\n/* ***************************************** Contact **************************************** */\n\n#contact {\n    padding: 50px;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-around;\n    align-items: center;\n}\n\n.leaflet-container {\n    height: 400px;\n    width: 50%; \n    box-shadow: 8px 8px 10px rgba(0, 0, 0, 0.6);\n}\n\n.contact {\n    width: 40%;\n}\n\n.contactLigne {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    margin-bottom: 20px;\n}\n\n.contactColonne {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 40px;\n}\n\n.contactLigne p {\n    font-weight: 700;\n    color: var(--text);\n}\n\n.contactColonne .small {\n    font-size: 11px\n}\n\n.contactLigne img {\n    height: 30px;\n    margin: 0 20px;\n}\n\n.contactLigne .sociaux {\n    margin: 0;\n    margin-left: 20px;\n}\n\n@media screen and (max-width: 768px) {\n\n    #contact {\n        flex-direction: column;\n    }\n\n    .leaflet-container {\n        height: 300px;\n        width: 100%;\n        box-shadow: 5px 5px 8px rgba(0, 0, 0, 0.6);\n    }\n\n    .contact {\n        width: 100%;\n        margin-top: 30px;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n    }\n\n    .contactLigne {\n        margin-bottom: 10px;\n    }\n}\n\n/* ***************************************** Footer **************************************** */\n\nfooter {\n    background-color: var(--secondary);\n    padding: 20px 20px 10px 20px;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n}\n\nfooter div {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-around;\n    width: 20%;\n}\n\nfooter a {\n    text-decoration: none;\n    color: var(--text);\n}\n\n@media screen and (max-width: 768px) {\n\n    footer div {\n        width: 50%;\n    }\n}\n\n\n/* ***************************************** CGV et Mentions légales **************************************** */\n\n.conditions {\n    padding: 30px 80px;\n}\n\n.conditions div {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 30px;\n}\n\n.buttonAccueil {\n    padding: 10px 20px;\n    border-radius: 10px;\n    border: 0;\n    background-color: var(--primary);\n    box-shadow: 5px 5px 8px rgba(0, 0, 0, 0.6);\n    font-weight: bold;\n}\n\n.conditions h1 {\n    font-size: 28px;\n    margin-bottom: 20px;\n}\n\n.conditions h2 {\n    font-size: 20px;\n    margin: 20px 0 10px 0;\n}\n\n.conditions h3 {\n    font-size: 18px;\n    font-weight: normal;\n    text-decoration: underline;\n    margin: 20px 0 10px 0;\n}\n\n.conditions .credits h3 {\n    text-decoration: none;\n    margin: 40px 0 10px 0;\n}\n\n.conditions ul {\n    padding-left: 30px;\n    margin-bottom: 10px;\n}\n\n.conditions section {\n    margin-bottom: 15px;\n}\n\n@media screen and (max-width: 768px) {\n\n    .conditions {\n        padding: 30px;\n    }\n}\n\n/* *****************************************  Page 404  ***************************************** */\n\n.page404 {\n    height: 100vh;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-evenly;\n    align-items: center;\n}\n\n.page404 img {\n    width: 60%;\n    height: 200px;\n    object-fit: cover;\n    border-radius: 20px;\n}\n\n.page404 h1 {\n    font-size: 10em;\n    color: red;\n}\n\n@media screen and (max-width: 400px) {\n    .page404 h1 {\n        font-size: 4.5em;\n    }\n}\n\n@media screen and (max-width: 768px) {\n\n    .page404 img {\n        width: 70%;\n    }\n\n    .page404 h1 {\n        font-size: 6.3em;\n    }\n}\n\n\n/* *****************************************  Grands écrans  ***************************************** */\n\n@media (min-width: 1400px) {\n    h1 {\n        font-size: 2.7vw;\n    }\n    \n    h2 {\n        font-size: 1.8vw;\n    }\n    \n    h3 {\n        font-size: 1.5vw;\n    }\n\n    h4 {\n        font-size: 1.3vw;\n    }\n    \n    p {\n        font-size: 1.1vw;\n    }\n\n    .desktop-menu {\n        font-size: 1.5vw;\n    }\n\n    .desktop-menu ul {\n        padding: 0 2.1vw;\n    }\n    \n    .desktop-menu ul li {\n        padding: 0 0.7vw;    \n    }\n\n    .ouvferm h2 {\n        font-size: 2.7vw;\n    }\n\n    .ouvferm {\n        bottom: 3vw;\n    }\n\n    .logo {\n        width: 7.4vw;\n    }\n\n    .logoAccueil {\n        width: 29.6vw;\n    }\n\n    #restaurant h1 {\n        margin: 1.5vw 0 3vw 0;\n    }\n    #restaurant p {\n        margin-bottom: 1.5vw;\n    }\n\n    #menu {\n        padding: 0 5.2vw;\n    }\n\n    .menus h2 {\n        margin-bottom: 3vw;\n    }\n\n    .menuPart h3 {\n        margin-bottom: 1.5vw;\n    }\n\n    .menuButton {\n        font-size: 1.8vw;\n        width: 11.1vw;\n        height: 5.2vw;\n    }\n\n    .longButton {\n        width: 100%;\n    }\n\n    #cuisine h2 {\n        padding: 1.5vw 0;\n    }\n    \n    #cuisine p {\n        margin-bottom: 1.5vw;\n    }\n\n    .cuisineText h3 {\n        font-size: 1.2vw;\n    }\n    #reservation {\n        padding: 2.2vw 3.7vw;\n    }\n\n    .reservationGoogle .close {\n        padding: 0.4vw 0.7vw;\n    }\n    \n    .reservationGoogle h2 {\n        margin-bottom: 1.5vw;\n    }\n    \n    .reservationGoogle button {\n        padding: 0.7vw 2.2vw;\n        font-size: 1.2vw;\n    }\n\n    .formulaire {\n       margin-bottom: 0.7vw;\n    }\n\n    .formulaire2 p {\n        margin-right: 0.7vw;\n    }\n    \n    .formulaire2 input {\n        margin-right: 0.7vw;\n        padding: 0 0.7vw;\n    }\n    \n    .formulaire p {\n        margin-right: 0.4vw;\n    }    \n\n    input {\n        height: 1.3vw;\n        font-size: 1.1vw;\n    }\n\n    #time {\n        width: 3vw;\n    }\n\n    textarea {\n        padding: 0.7vw;\n        height: 11.1vw;\n        border-radius: 0.7vw;\n        margin-top: 0.4vw;\n    }\n\n    #contact {\n        padding: 3.7vw;\n    }\n\n    .leaflet-container {\n        height: 29.6vw;\n    }\n\n    .contactLigne {\n        margin-bottom: 1.5vw;\n    }\n\n    .contactLigne img {\n        height: 2.2vw;\n        margin: 0 1.5vw;\n    }\n\n    footer {\n        padding: 1.5vw 1.5vw 0.7vw 1.5vw;\n    }\n\n\n    .conditions {\n        padding: 30px 80px;\n    }\n    \n    .conditions div {\n        display: flex;\n        justify-content: center;\n        margin-bottom: 30px;\n    }\n    \n    .buttonAccueil {\n        padding: 0.7vw 1.5vw;\n        border-radius: 0.7vw;\n    }\n    \n    .conditions h1 {\n        font-size: 2.1vw;\n        margin-bottom: 1.5vw;\n    }\n    \n    .conditions h2 {\n        font-size: 1.5vw;\n        margin: 1.5vw 0 0.7vw 0;\n    }\n    \n    .conditions h3 {\n        font-size: 1.3vw;\n        margin: 1.5vw 0 0.7vw 0;\n    }\n    \n    .conditions ul {\n        padding-left: 2.2vw;\n        margin-bottom: 0.7vw;\n    }\n    \n    .conditions section {\n        margin-bottom: 1.1vw;\n    }\n\n    .page404 img {\n        height: 14.8vw;\n        border-radius: 1.5vw;\n    }\n\n    .page404 h1 {\n        font-size: 12vw;\n        color: red;\n    }\n}\n\n/* Mise en avant promotion */\n\n.miseEnAvant {\n    background: red;\n    color: var(--textException);\n    margin-top: 4vw;\n    width: 300px;\n}\n\n@media screen and (max-width: 768px) {\n    .miseEnAvant {\n        margin-top: 7vw;\n        height: 65px;\n        width: 6em;\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .miseEnAvant {\n        width: 200px;\n    }\n}\n\n\n\n.hidden {\n    display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
